import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import {
    fetchSocialCalloutsByObjective,
} from 'services/social/duck';

import { SocialObjectiveDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import EventResponsesModule from 'components/organisms/social/EventResponsesModule';

class EventResponsesContainer extends SocialObjectiveDashboardComponent {
    constructor(props, { objective = 'EVENT_RESPONSES' } = {}) {
        super(props, objective);
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const objective = this.getCurrentObjective();
        const payload = this.createPayload(entityId, objective);

        this.props.fetchSocialCalloutsByObjective(payload);
    }

    render() {
        return (
            <EventResponsesModule module={this.props.module}
                xAxisLabel={this.props.xAxisLabel}
                backfillBuckets={this.props.backfillBuckets}
                objective={this.getCurrentObjective()}
                layer={this.props.layer}
            />
        );
    }
}

const mapStateToProps = state => ({
    entityMeta: state.entities.meta,
    module: state.social.facebook.objectives.EVENT_RESPONSES,
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', [])
});

export default connect(mapStateToProps, {
    fetchSocialCalloutsByObjective,
})(EventResponsesContainer);



// WEBPACK FOOTER //
// ./src/containers/dashboards/social/EventResponsesContainer.js